export default "__VITE_ASSET__DjAS8MbX__"